import { SVGProps, Ref, forwardRef } from 'react';

export const VkSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M12.983 18.928C5.466 18.928 1.178 13.775 1 5.2h3.765c.124 6.293 2.9 8.96 5.098 9.509V5.2h3.546v5.428c2.17-.234 4.451-2.707 5.221-5.428h3.545c-.59 3.353-3.064 5.826-4.823 6.843 1.759.825 4.576 2.982 5.648 6.885h-3.903c-.838-2.611-2.926-4.631-5.689-4.906v4.906z"
                fill="currentColor"
            />
        </g>
    </svg>
));
VkSolidSize24Glyph.displayName = 'VkSolidSize24Glyph';
